// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestOperationTemplateId } from './HarvestOperationTemplate';
import { z } from 'zod';
export const harvestAttributeLineageId = (z.string());
export const harvestAttributeLineage = z.object({
    id: harvestAttributeLineageId,
    template_id: harvestOperationTemplateId,
    created_at: z.date(),
});
export const harvestAttributeLineageInitializer = z.object({
    id: harvestAttributeLineageId.optional(),
    template_id: harvestOperationTemplateId,
    created_at: z.date().optional(),
});
export const harvestAttributeLineageMutator = z.object({
    id: harvestAttributeLineageId.optional(),
    template_id: harvestOperationTemplateId.optional(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=HarvestAttributeLineage.js.map